import { Box, Button, Modal } from "@mui/material";
import { useState } from "react";
import STEP from "../../../constants/STEP";
import { useBudgetFormContext } from "../../../context/BudgetFormContext";
import BudgetAccommodationSelect from "../BudgetAccommodationSelect";

const FirstActions = () => {
  const { handleCancel, handleNextStep, handleSubmitBudgetRequest, budgets } = useBudgetFormContext();

	const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = async () => {
    setModalOpen(!modalOpen);
  };

  const [modalCanalDiretoOpen, setModalCanalDiretoOpen] = useState(false);

  const handleOpenModalCanalDireto = async () => {
      setModalCanalDiretoOpen(!modalCanalDiretoOpen);
  };

  const handleSubmitModal = (data) => {
    handleSubmitBudgetRequest(data)

    if(modalOpen){
      handleOpenModal()
    } else {
      handleOpenModalCanalDireto()
    }
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}>
      <Button
        sx={{ marginRight: 2, minWidth: "100px", textTransform: "capitalize" }}
        color="fourth"
        variant="contained"
        onClick={handleCancel}
      >
        Cancelar
      </Button>
      <Button
        sx={{ textTransform: "capitalize", minWidth: "100px", color: "#fff" }}
        color="tertiary"
        variant="contained"
        onClick={handleNextStep}
        disabled={budgets.length === 0}
      >
        Próxima Etapa
      </Button>
    </Box>
  );
};

const SecondActions = () => {
  const { handleBackStep, handleSubmit, handleSubmitPayLink, budgets, mail, budgetRequest, budgetRequestCanalDireto, formType, handleSubmitBudgetRequest } = useBudgetFormContext();
  const [mainUhModalOpen, setMainUhModalOpen] = useState(false);

  const handleOpenModalUh = async () => {
    setMainUhModalOpen(!mainUhModalOpen);
  };

  const budget_type = formType === "callCenter" ? 1 : 2

  const budgetRequestData = (budget_type == 1 || budget_type == '1') ? budgetRequest : budgetRequestCanalDireto

  const handleSubmitModalUh = async (acommodation_description, paymentType) => {
    await handleSubmitPayLink(acommodation_description, paymentType, budget_type)
    handleOpenModal();
  };

  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = async () => {
    setModalOpen(!modalOpen);
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}>
      <Button
        sx={{ marginRight: 2, textTransform: "capitalize" }}
        color="fourth"
        variant="contained"
        onClick={handleBackStep}
      >
        Voltar
      </Button>
      {budget_type === 1 &&
        <Button
          sx={{ marginRight: 2, textTransform: "capitalize", color: "#fff" }}
          color="fifth"
          variant="contained"
          onClick={() => handleOpenModalUh()}
          disabled={budgets.length === 0 || (mail.clientNameError || (mail.clientEmailError && mail.clientEmail.length > 0) || mail.clientPhoneError)}
        >
          Link Pagamento
        </Button>
      }
      <Button
        sx={{ marginRight: 2, minWidth: "160px", textTransform: "capitalize", color: "#fff" }}
        color="primary"
        variant="contained"
        onClick={()=>handleSubmitBudgetRequest(budget_type)}
        disabled={budgets.length === 0 || 
          (mail.clientNameError  || 
            mail.clientPhoneError ||
            (mail.clientEmailError && mail.clientEmail.length > 0)
          ) || 
          !budgetRequestData.budgetRequestValido
        }
      >
        Salvar
      </Button>
      <Button
        sx={{ textTransform: "capitalize", color: "#fff" }}
        color="tertiary"
        variant="contained"
        onClick={() => handleSubmit(budget_type)}
        // onClick={budget_type === 1 ? handleOpenModal : handleOpenModalCanalDireto}
        disabled={budgets.length === 0 || 
          (mail.clientNameError  || 
            mail.clientPhoneError ||
            (mail.clientEmailError && mail.clientEmail.length > 0)
          ) || 
          !budgetRequestData.budgetRequestValido
        }
      >
        Enviar
      </Button>
      <Modal
        open={mainUhModalOpen}
        onClose={() => setMainUhModalOpen(false)}
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 1200,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          overflowY: 'auto',
        }}>
          <BudgetAccommodationSelect budget={budgets[0]} handleSubmitModal={handleSubmitModalUh} />
        </Box>
      </Modal>
    </Box>
  );
};

const FormActions = () => {
  const { step } = useBudgetFormContext();

  return (
    <>
      {step === STEP.BUDGET && <FirstActions />}
      {step === STEP.EMAIL && <SecondActions />}
    </>
  );
};

export default FormActions;
